import { Component, ComponentInterface, h, Prop, Listen } from '@stencil/core';
import { getCookie, guid, setCookie } from 'utils';

declare var onCookieAccept;

@Component({
  tag: 'kdx-cookie-message',
  styleUrl: 'kdx-cookie-message.scss',
  shadow: false,
})
export class StCookieMessage implements ComponentInterface {

	/**
	 * Assigns a required unique id to the general alert
	 */
	@Prop() cookieMsgId: string = `kdx-cookie-message-${guid()}`;

	/**
	 * Provides a string of any additional classes for the cookie message
	 */
	@Prop() cookieMsgClasses: string = "alert-primary";

	/**
	 * Provides input to change URL of alert's first button
	 */
	@Prop() btnHref: string;

	/**
	 * Provides a string of classes for the cookie message's dismiss button
	 */
	@Prop() btnClasses: string = "btn-primary";

	/**
	 * Provides input to change text of alert's dismiss button, btnClasses should also be provided when using this.
	 */
	@Prop() btnText: string = "I Accept";

	/**
	 * Provides input to change label of alert's first button; btnClasses should also be provided when using this.
	 */
	@Prop() btnLabel: string;

	/**
	 * Provides input to change icon of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnIcon: string;

	/**
	 * Provides input to change URL of alert's second button
	 */
	@Prop() btnTwoHref: string;

	/**
	 * Provides a string of classes for the alert's optional second button
	 */
	@Prop() btnTwoClasses: string;

	/**
	 * Provides input to change label of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoLabel: string;

	/**
	 * Provides input to change text of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoText: string;

	/**
	 * Provides input to change icon of alert's second button; btnTwoClasses should also be provided when using this.
	 */
	@Prop() btnTwoIcon: string;

	/**
	 * Name of cookie used to track user consent
	 */
	@Prop() cookieName: string = 'UserCookie';

	/**
	 * Determines if cookie message should be displayed
	 */
	 private shouldRender: boolean;

	/**
	 * When event is emitted set session storage.
	 */
	@Listen('dismissTriggered')
	handleDismissTriggered() {
		setCookie(this.cookieName, 'true', 30);
		this.shouldRender = false;
	}

	componentWillLoad() {
		const consent = getCookie(this.cookieName);

		if (!consent) {
			this.shouldRender = true;
		} else {
			this.shouldRender = false;
		}
	}
	
	render() {
		if (this.shouldRender) {
			return (
				<kdx-alert 
					alert-id={this.cookieMsgId} 
					alert-classes={`${this.cookieMsgClasses} cookie-message`} 
					btn-href={this.btnHref}
					btn-classes={`btn ${this.btnClasses}`} 
					btn-text={this.btnText}
					btn-label={this.btnLabel}
					btn-icon={this.btnIcon}
					btn-two-href={this.btnTwoHref}
					btn-two-classes={this.btnTwoClasses}
					btn-two-label={this.btnTwoLabel}
					btn-two-text={this.btnTwoText}
					btn-two-icon={this.btnTwoIcon}
					dismissible={true}>
					<slot />
				</kdx-alert>
			);
		} else {
			return (<div style={{display: 'none'}}>
				<slot />
			</div>);
		}
	}
}